import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/Scrolltotop';
import WhatsAppButton from '../components/WhatsAppButton';
import PageNotFound from '../pages/PageNotFound';
import PropertyDetails from '../pages/PropertyDetails';
import Aboutus from '../pages/Aboutus';
import Contactus from '../pages/Contactus';
import ResidentialsList from '../pages/ResidentialsList';
import HeroSection from '../pages/Home/HeroSection';
import Layout from '../components/Layout';
import EMICalculator from '../pages/Propertyguide/EMICalculator';
import HomeLoan from '../pages/Propertyguide/HomeLoan';
import Blog from '../pages/Home/Blog';
import BlogDetail from '../pages/Home/BlogDetail';
import Faq from '../pages/Propertyguide/Faq';
import Comingsoon from '../pages/Comingsoon';
import PdfViewer from '../pages/PdfViewer';
import useMetaTags from '../hooks/useMetaTags';
import Interier from '../pages/Interier';

const Pageroutes = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  // Initialize meta tags
  useMetaTags();

  return (
    <>
      {!isHomePage && <Navbar />}
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<HeroSection />} />
          <Route path="/propertydetails" element={<PropertyDetails />} />
          <Route path="/propertydetails/:id" element={<PropertyDetails />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/propertylist" element={<ResidentialsList />} />
          <Route path="/properties" element={<ResidentialsList />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/interior-design" element={<Interier />} />
          <Route path="/blog-detail" element={<BlogDetail />} />
          <Route path="/home-loan" element={<Layout />}>
            <Route index element={<HomeLoan />} />
          </Route>
          <Route path="/emi-calculator" element={<Layout />}>
            <Route index element={<EMICalculator />} />
          </Route>
        
          {/* <Route path="/docs-required" element={<Layout />}>
            <Route index element={<DocsRequired />} />
          </Route>
          <Route path="/property-buying-steps" element={<Layout />}>
            <Route index element={<PropertyBuyingSteps />} />
          </Route>
          <Route path="/vaastu-tips" element={<Layout />}>
            <Route index element={<VaastuTips />} />
          </Route>
          <Route path="/builder-partners" element={<Layout />}>
            <Route index element={<BuilderPartners />} />
          </Route> */}

          <Route path="/docs-required" element={<Comingsoon />} />
          <Route path="/property-buying-steps" element={<Comingsoon />} />
          <Route path="/vaastu-tips" element={<Comingsoon />} />
          <Route path="/builder-partners" element={<Comingsoon />} />
          <Route path="/home-loan-facility" element={<Comingsoon />} />
          <Route path="/interior-design" element={<Comingsoon />} />
          <Route path="/faqs" element={<Layout />}>

            <Route index element={<Faq />} />
          </Route>

          <Route path="/pdf-viewer" element={<PdfViewer />} />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ScrollToTop>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default Pageroutes;
